import React from "react"
import { Button, Form } from "antd"

import { observer } from "mobx-react"
import AppStore from "../../Configs/Store"

const GenericButton = observer(({ buttonStyle = "calculateFormButton", className, title, onClick, type, isDisabled, ...props }) => {
  const device = AppStore.device

  return (
    <Form.Item className={className}>
      <Button
        htmlType="submit"
        className={buttonStyle}
        style={device === 0 ? styles[0].buttonForm : styles[1].buttonForm}
        type="primary"
        shape="round"
        size={"large"}
        onClick={onClick}
        disabled={isDisabled}
        {...props}
      >
        {title}
      </Button>
    </Form.Item>
  )
})

const styles = {
  1: {
    buttonForm: {
      width: 297,
      height: 52,
    },
  },
  0: {
    buttonForm: {
      width: 297,
      height: 44,
    },
  },
}

export default GenericButton
